<ng-container *ngIf="isRenew === true; else header202009">
  <app-header202208 (goPageEmitter)="goPageEmitter($event)"></app-header202208>
</ng-container>
<ng-template #header202009>
  <app-header202009></app-header202009>
</ng-template>